"use client";

import { Avatar, Badge, Skeleton } from 'antd';
import { useState, useEffect } from 'react';
import { chatList, deleteOrdersByEventId } from "@/service/message/index";
import useMobileDetect from "@/hooks/useMobileDetect";
import Link from "next/link";

import {
  DeleteOutlined
} from '@ant-design/icons';

import "./chat-list.css";

export type ChatListProps = {
  chatId?: string,
}

type chatData = {
  chatDesc: string,
  chatIcon: string,
  chatId: string,
  chatName: string,
  createTime: string,
  lastMsgTime: string,
  lastUserMsgTime: string,
  relationId: string,
  relationType: string,
  unReadCount: null | number,
  userId: null | string,
}
export const ChatList: React.FC<ChatListProps> = ({ chatId, ...props }) => {
  const [list, setList] = useState<chatData[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const isMobile = useMobileDetect();

  useEffect(() => {
    chatList<chatData[]>().then(res => {
      if (res.code === 0) {
        setList(res.data)
      }
    })
  }, []);

  const deleteOrdersByEventIdFunc = async (e: React.MouseEvent<HTMLElement>, id: string) => {
    e.stopPropagation()
    await deleteOrdersByEventId(id)
    chatList<chatData[]>().then(res => {
      if (res.code === 0) {
        setList(res.data)
      }
    })
  }

  const navigatoChat = (item: chatData) => {
    if (item.chatId) {
      localStorage.setItem("chat_title", item.chatName)
      if (isMobile) {
        location.href = `/chat/${item.chatId}/${item.relationId || 'null'}/${item.relationType || 'null'}`
      } else {
        location.href = `/message?chatId=${item.chatId}&relationId=${item.relationId || 'null'}&relationType=${item.relationType || 'null'}`
      }

    } else {
      globalThis.localStorage.setItem("login_redirect", location.href)
      document.getElementById("signInButton")?.click();
    }
  }

  return (
    <div className="cardList">
      {
        !list.length ?
          <div className='px-20 pt-20'>
            <div className='cardItem_race pt-20'>
              <Skeleton active />
            </div>
            <div className='cardItem_race pt-20'>
              <Skeleton active />
            </div>
            <div className='cardItem_race pt-20'>
              <Skeleton active />
            </div>
          </div>
          :
          list.map((item, index) => (
            <div
              style={{ background: chatId == item.chatId ? 'rgba(0, 242, 252, 0.1)' : '' }}
              className="flex px-20 py-10 cursor-pointer"
              key={index}
              onClick={() => navigatoChat(item)}
            >
              <Badge count={item.unReadCount || 0} >
                <Avatar shape="square" size="large" src={item.chatIcon} alt={item.chatName}
                  style={{ width: '6rem', height: '6rem', borderRadius: '50%' }} />
              </Badge>
              <div className="flex-1 ml-20">
                <div className="flex justify-between items-center">
                  <span className="text-15 font-bold text-white leading-20">{item.chatName}</span>
                  <div className="flex items-center">
                    <DeleteOutlined style={{ fontSize: '1.4rem', color: 'rgba(255, 255, 255, 0.5)' }}
                      onClick={e => deleteOrdersByEventIdFunc(e, item.chatId)} />
                    <span className="text-bravve-sub-500 text-11 whitespace-nowrap ml-10">{item.lastMsgTime}</span>
                  </div>
                </div>
                <div className="text-bravve-sub-500 text-13 leading-18 mt-5 h3">
                  {item.chatDesc}
                </div>
              </div>
            </div>
          ))
      }
    </div>
  )
}
